import * as React from 'react';
import { translate } from 'elc-service';
import { FilterSet } from '../../../domain/entities/FilterSet';
import styled from 'styled-components';
import { Row } from 'elc-grid';
import { ContentSpacing } from 'elc-base-theme';
import { classes } from '../../../utils/Classes';
import { FilterItem } from './FilterItem';

export interface IFiltersList {
    productsNumber: number;
    appliedFilters: FilterSet[];
    translations?: IFiltersListTranslations;
}

export interface IFiltersListTranslations {
    applyFiltersLabel: string;
}

const StyledSelectedTagsRow = styled(Row)`
    padding: ${ContentSpacing.space6} 0 ${ContentSpacing.space40};
`;

@translate(['applyFiltersLabel'])
export class FiltersList extends React.Component<IFiltersList> {
    render() {
        const styledSelectedCategoryRowClassnames = classes('styled-filters-selected-category-row');
        const { applyFiltersLabel } = this.props.translations as IFiltersListTranslations;

        return (
            <StyledSelectedTagsRow className={styledSelectedCategoryRowClassnames}>
                {this.props.appliedFilters.length &&
                    this.props.appliedFilters.reduce(
                        (appliedFilters: JSX.Element[], filterSet: FilterSet) => {
                            return appliedFilters.concat(
                                filterSet.activeFilters.map(filter => (
                                    <FilterItem
                                        ariaLabel={applyFiltersLabel}
                                        filter={filter}
                                        className="elc-link"
                                        key={filter.key}
                                    />
                                ))
                            );
                        },
                        []
                    )}
            </StyledSelectedTagsRow>
        );
    }
}
